module.exports = {"baseUrl":"https://i2oc.com","downloadButton":{"enable":false,"postgresUrl":null,"i2ocApplicationUrl":null}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 201
// module chunks = 1